export const APPLICANT_LEVEL_EDU_BASIC = 1;
export const APPLICANT_LEVEL_EDU_SECONDARY = 2;
export const APPLICANT_LEVEL_EDU_SPO = 3;
export const APPLICANT_LEVEL_EDU_VO = 4;
export const APPLICANT_LEVEL_CERTIFICATE_CARD = 5;
export const APPLICANT_LEVEL_EDU_BASIC_PROF_DIPLOMA = 6;
